import { actions, assign, createMachine } from 'xstate';
import { assignAvailableCredit, enrollInOneClickAutopay, fetchAccountSummary, makePayment, maybeDeleteAlternatePaymentMethod, sendResultToParentMachine } from './helpers';
const paymentMachine = createMachine({
    id: 'payment',
    predictableActionArguments: true,
    initial: 'makingPayment',
    states: {
        makingPayment: {
            entry: assignAvailableCredit('availableCreditBeforePayment'),
            invoke: {
                src: 'makePayment',
                onDone: [
                    {
                        target: 'enrollingInOneClickAutopay',
                        cond: 'shouldEnrollInOneClickAutopay',
                        actions: 'savePaymentResponse'
                    },
                    {
                        target: 'fetchingAccountSummary',
                        actions: 'savePaymentResponse'
                    }
                ],
                onError: {
                    target: 'maybeDeletingAlternatePaymentMethod',
                    actions: 'savePaymentResponse'
                }
            }
        },
        enrollingInOneClickAutopay: {
            invoke: {
                src: 'enrollInOneClickAutopay',
                onDone: {
                    target: 'fetchingAccountSummary',
                    actions: assign({
                        hasOneClickAutopayError: false
                    })
                },
                onError: {
                    target: 'fetchingAccountSummary',
                    actions: assign({
                        hasOneClickAutopayError: true
                    })
                }
            }
        },
        fetchingAccountSummary: {
            invoke: {
                src: 'fetchAccountSummary',
                onDone: {
                    target: 'success',
                    actions: assignAvailableCredit('availableCreditAfterPayment')
                },
                onError: 'success'
            }
        },
        maybeDeletingAlternatePaymentMethod: {
            invoke: {
                src: 'maybeDeleteAlternatePaymentMethod',
                onDone: 'error',
                onError: 'error'
            }
        },
        success: {
            type: 'final',
            data: sendResultToParentMachine
        },
        error: {
            type: 'final',
            entry: actions.escalate(sendResultToParentMachine)
        }
    }
}, {
    actions: {
        savePaymentResponse: assign((context, { data: response }) => {
            const { status, body } = response;
            return {
                paymentStatus: status,
                paymentBody: body
            };
        })
    },
    guards: {
        shouldEnrollInOneClickAutopay: ({ shouldEnrollInOneClickAutopay }) => {
            return shouldEnrollInOneClickAutopay;
        }
    },
    services: {
        enrollInOneClickAutopay,
        fetchAccountSummary,
        makePayment,
        maybeDeleteAlternatePaymentMethod
    }
});
export default paymentMachine;
